<template>
  <div class="cursor-pointer flex w-min py-0.5 rounded-full px-2 items-center bg-gray-50 border" @click="goBack">
    <FontAwesomeIcon  :icon="['far', 'circle-left']" />
    <div class="ml-1">Back</div>
  </div>

</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircleLeft} from '@fortawesome/free-regular-svg-icons'

library.add(faCircleLeft)

export default {
  name: 'BackButton',
  components: {FontAwesomeIcon},
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>